import {
  fetchUptimeReportAction,
  unloadUptimeAction,
} from "fleet/redux-store/ui-state/report-uptime/actions";
import { uptimeReportSelector } from "fleet/redux-store/ui-state/report-uptime/selectors";
import { UptimeReportPage } from "fleet/view/report/uptime";
import { connect } from "react-redux";
import { storesReady } from "redux-store";
import { devicesSelector } from "redux-store/devices";
import { networksSelector } from "redux-store/networks";
import { makeGetSelectOptions } from "redux-store/selectors";

const getNetworkSelectOptions = makeGetSelectOptions();

function mapStateToProps(state, props) {
  const { networkId, start, end } = props.match.params || {};

  const storesLoaded = storesReady(state.global.devices, state.global.networks);
  const devices = devicesSelector(state);
  const networks = networksSelector(state);
  const network = networks[networkId];
  const networkOptions = getNetworkSelectOptions(networks);
  const report = uptimeReportSelector(state);

  return {
    devices,
    end,
    network,
    networks,
    networkOptions,
    report,
    start,
    storesLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchUptimeReport: (serviceArgs) => {
      return new Promise((resolve, reject) => {
        dispatch(
          fetchUptimeReportAction({
            reject,
            resolve,
            serviceArgs,
          }),
        );
      });
    },

    unloadAdDeliveryReport: () => {
      return dispatch(unloadUptimeAction);
    },
  };
}

const ConnectedUptime = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UptimeReportPage);

export { ConnectedUptime };
